import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import Submitting from 'shared/Submitting.jsx';
import StandardField from 'shared/StandardField.jsx';
import StandardSelectField from 'shared/StandardSelectField.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';

const BundlingRuleItemForm = ({
  eventTypes,
  handleSubmit,
  submitting,
  onCancel,
  onSubmit
}) => (
  <form
    className="animated fadeIn"
    onSubmit={handleSubmit(onSubmit)}
    noValidate
  >
    <div className="panel panel-primary">
      <div className="panel-body">
        <div className="flex justify-content direction-column">
          <h2 className="panel-body-sub-heading">{`General (Required)`}</h2>
          <ErrorListContainer />
          <Field
            autofocus
            component={StandardSelectField}
            name="parentEventId"
            options={eventTypes}
            placeholder="Parent Event"
            simpleValue
            searchable={false}
          />
          <Field
            name="quantity"
            type="number"
            component={StandardField}
            step="1"
            min="0"
            placeholder="Quantity"
          />
          <Field
            component={StandardSelectField}
            name="childEventId"
            options={eventTypes}
            placeholder="Child Event"
            simpleValue
            searchable={false}
          />
        </div>
        <hr />
        <div className="form-group text-right">
          <button
            type="button"
            className="btn btn-link"
            disabled={submitting}
            onClick={onCancel}
          >Cancel</button>
          {` `}
          <button
            type="submit"
            className="btn btn-primary btn-lg"
            disabled={submitting}
          >{submitting ? <Submitting /> : <i className="fa fa-floppy-o" />} {`Save`}</button>
        </div>
      </div>
    </div>
  </form>
);

BundlingRuleItemForm.propTypes = {
  eventTypes: PropTypes.arrayOf(PropTypes.object),
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func
};

export default reduxForm({
  form: 'bundlingRuleItemForm'
})(BundlingRuleItemForm);



// WEBPACK FOOTER //
// ./src/features/tournament/restrictions/bundles/BundlingRuleItemForm.jsx